import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

const StyledSportsExtraContentWrapper = styled.div`
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  padding-right: 10px;
  display: grid;
  justify-items: flex-end;
`

const SportsExtraContentWrapper: FunctionComponent<{
  children?: ReactNode
}> = ({ children }) => {
  return (
    <StyledSportsExtraContentWrapper>
      {children}
    </StyledSportsExtraContentWrapper>
  )
}

export default SportsExtraContentWrapper
